export const environment = {
  production: false,
  apiUrl: 'https://staging.emsitpro.com/api/v1',
  mcpUrl: 'https://mcp.emsitpro.com',
  apiGatewayUrl: 'https://api-gw.emsitpro.com/v1/service',
  httpCredential: false,
  stsAuthority: 'https://sso.emsitpro.com/',
  clientId: 'emserp_web_app',
  clientSecret: '55d33e6c-557b-5e57-c009-cdfdbf6f183f',
  clientRoot: 'https://beta.emsitpro.com/',
  clientScope: 'openid profile email roles emserp_backend_api ems_identity_admin_api',
  weblogUrl: 'https://staging.emsitpro.com/api/callback/weblog',
  apiSsoUrl: 'https://api.sso.emsitpro.com',
  accurateAol: 'https://account.accurate.id/oauth/authorize',
  pusherKey: 'f18ffa0d17b54ab0794c',
  pusherCluster: 'ap1',
  jiraUrl: 'https://auth.atlassian.com/authorize',
};
